export default __webpack_public_path__ + "static/media/referencing_launch_icon.9d9a66ef.svg";